import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  width: 13px;
  height: 19px;
`

export const LocationIcon2 = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 7C0.5 3.67614 3.17614 1 6.5 1C9.82386 1 12.5 3.67614 12.5 7C12.5 7.78733 12.1642 8.87416 11.6 10.1077C11.0429 11.3256 10.2906 12.6288 9.51719 13.8292C8.74437 15.0286 7.95703 16.1151 7.33501 16.8984C7.02322 17.2911 6.75805 17.6011 6.56037 17.8091C6.53907 17.8315 6.51894 17.8524 6.5 17.8716C6.48105 17.8524 6.46093 17.8315 6.43963 17.8091C6.24195 17.6011 5.97678 17.2911 5.66499 16.8984C5.04297 16.1151 4.25563 15.0286 3.48281 13.8292C2.70937 12.6288 1.95708 11.3256 1.40001 10.1077C0.835816 8.87416 0.5 7.78733 0.5 7ZM3.5 7C3.5 8.67614 4.82386 10 6.5 10C8.17614 10 9.5 8.67614 9.5 7C9.5 5.32386 8.17614 4 6.5 4C4.82386 4 3.5 5.32386 3.5 7Z"
        fill="none"
        stroke="#916EE8"
      />
    </Svg>
  )
}
